export default __webpack_public_path__ + "static/media/minus_icon.8b5487b0.svg";